<template>
  <section id="userIndex">
    <v-card class="shadow-1 mt-15">
      <v-row justify="center" class="py-10" v-if="noDataSelected">
        <v-col cols="auto">
          <p class="text-body-1">No hay datos seleccionados</p>
        </v-col>
      </v-row>
      <!-- Gráficas -->
      <v-container fluid v-else>
        <v-row align="center" justify="center">
          <v-col cols="12" v-if="render">
            <v-card outlined>
              <v-card-text>
                <div id="chart">
                  <div class="toolbar">
                    <button
                      id="all"
                      @click="updateData('all')"
                      :class="
                        `selectionbtn ${selection === 'all' ? 'selectionActive' : ''}`
                      "
                    >
                      ALL
                    </button>
                  </div>

                  <div id="chart-timeline">
                    <apexchart
                      type="area"
                      height="350"
                      ref="chart"
                      :options="chartOptions"
                      :series="series"
                    ></apexchart>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-else-if="!render" cols="12">
            <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card">
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- MODAL DE RANGO DE FECHA -->

    <v-dialog v-model="active" scrollable max-width="600">
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card>
          <v-progress-linear
            v-if="isLoadingDialog"
            indeterminate
            color="primary"
            rounded
            height="6"
          ></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Informe personalizado
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <v-col cols="12">
                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          rules="required"
                          name="Rango de Fecha"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="dates"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            label="Rango de fecha"
                            readonly
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                          >
                            Cancelar
                          </v-btn>
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoadingDialog"
                            :disabled="isLoadingDialog"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="dateRangeMenu = false"
                          >
                            ok
                          </v-btn>
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      rules="required"
                      name="Rango de Fecha"
                      v-slot="{ errors }"
                    >
                      <v-radio-group
                        v-model="payload.type"
                        class="px-4"
                        :error-messages="errors"
                        row
                      >
                        <v-radio label="Todas" :value="1"></v-radio>
                        <v-radio label="Entrantes" :value="2"></v-radio>
                      </v-radio-group>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoadingDialog"
                :disabled="dates.length < 2 || !payload.type"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="handleSubmit(getReports)"
              >
                Buscar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
import moment from "moment";
import RangeDateDialog from "../../components/DatePickers/DateRangePicker";

export default {
  components: { vuescroll, RangeDateDialog },
  props: {
    user: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      isLoading: true,
      isLoadingDialog: false,
      active: true,
      dateRangeMenu: false,
      noDataSelected: false,
      payload: { type: null },
      dates: [],
      render: false,
      series: [
        {
          name: "Canales",
          data: [],
        },
      ],
      chartOptions: {
        title: {
          text: "Canales activos en tiempo seleccionado",
        },
        chart: {
          id: "area-datetime",
          type: "area",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date().getTime(),
          tickAmount: 6,
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy HH:mm:ss",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },
      selection: "one_year",
    };
  },

  //   created() {
  //     this.getReports();
  //   },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  methods: {
    async getReports() {
      this.isLoadingDialog = true;
      try {
        const { data } = await PbxHttpClient.post("/report/channel_use", {
          ...this.payload,
          dateStart: this.dates[0],
          dateEnd: this.dates[1],
        });
        this.chartOptions.xaxis.min = moment(data.data[0].date)
          .toDate()
          .getTime();

        this.series[0].data = data.data.map(({ date, value }) => [
          moment(date)
            .toDate()
            .getTime(),
          value,
        ]);
        this.render = true;
        this.active = false;
      } catch (err) {}
      this.isLoadingDialog = false;
    },

    closeDialog() {
      this.active = false;
      this.noDataSelected = true;
    },
    updateData(timeline) {
      this.selection = timeline;

      switch (timeline) {
        case "all":
          this.$refs.chart.zoomX(
            moment(this.dates[0]).valueOf(),
            moment(this.dates[1]).valueOf()
          );
          break;
        default:
      }
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
.selectionActive {
  color: #fff !important;
  background: #008ffb !important;
  border: 1px solid blue !important;
  border-bottom: 2px solid blue !important;
}
.selectionbtn {
  background: #fff;
  color: #222;
  border: 1px solid #e7e7e7;
  border-bottom: 2px solid #ddd;
  border-radius: 2px;
  padding: 4px 17px;
}
</style>
